import { IInfluencer } from "@/models";
import { BaseRepository } from "@/repositories/BaseRepository";

class InfluencerRepository extends BaseRepository<IInfluencer> {
    constructor() {
        super("/influencers");
    }
}

const influencerRepository = new InfluencerRepository();

export { InfluencerRepository, influencerRepository };
